import React, {useEffect, useState, useMemo} from 'react';
import {connect} from "react-redux";
import {Link, useLocation} from "react-router-dom";
import {Button} from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LogoMobile from './../../../assets/images/logo-mobile.png';
import Image from 'react-bootstrap/Image';
import {logOutApi, loginforadmin} from "../../../api/auth/Auth";
import {setStore} from "../../../store/reducers/App";
import Store from "../../../store";
import {isCanceled} from "../../../utils/subscription";
import {
    create_quick_links,
    gas_quick_links,
    lottery_quick_links,
    other_quick_links
} from "../../../routing/routes/index";
import PermissionCheck from "../../../modules/Auth/PermissionCheck";
import TopNav from "../../../pages/partial/top-nav";
import {responseValidate} from '../../../utils/functions';
import { switchStoreApi } from '../../../api/auth/Auth';
import {updateDarkModeApi} from '../../../api/auth/Auth';
import {setDarkMode} from '../../../store/reducers/App';
import Modal from 'react-bootstrap/Modal';
import NotificationBell from '../../notification/notificationBell';
import { removeFCMToken } from '../../../firebase/fcm';

const Header = ({toggleMenuSidebar, saving, userName, stores, store, user, segment, darkMode}) => {

    const location = useLocation();

    const [savingState, setSavingState] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    
    useEffect(() => {
        document.body.classList.toggle('dark-mode', darkMode);
    }, [darkMode]);

    useEffect(() => {
        if (location.pathname !== "/daily_report")
            setSavingState(undefined);
        else {
            if (saving)
                setSavingState(saving);
            else
                setTimeout(() => setSavingState(saving), 1000)
        }
    }, [location.pathname, saving]);

    const handleThemeChange = async () => {
        const newDarkMode = !darkMode;
        document.body.classList.toggle('dark-mode', newDarkMode);
        setLoading(true);
        try {
            const response = await updateDarkModeApi(newDarkMode);
            const result = responseValidate(response);
            if (result.status) Store.dispatch(setDarkMode(result.data.dark_mode));
            else {
                document.body.classList.toggle('dark-mode', !newDarkMode);
            }
        } catch (error) {
            console.error("Theme update failed:", error);
            document.body.classList.toggle('dark-mode', !newDarkMode);
        } finally {
            setLoading(false);
        }
    };

    const switchStore = async(row) => {
        
        let item = localStorage.getItem("location");
        await switchStoreApi(row.id);
        if (item) {
            localStorage.clear(); 
        }
        
        localStorage.setItem("location", row?.id);
        
        Store.dispatch(setStore(row));
        window.location.reload();
    }
    

    const switchAdmin = async () => {
        try {
            
            await loginforadmin('admin@hisably.com', user.roles[0])
                .then(responseValidate).then(result => {
                    if (result.status) {
                        window.location.reload();
                    }
                })
        } catch (error) {
          console.error('Failed to fetch:', error);
        }
    };

   const trialDays = useMemo(() => {
        const trialEnd = store?.store_subscription?.trial_ends_at;
        const status = store?.store_subscription?.stripe_status;

        if (isCanceled(status)) return null;
        if (!trialEnd) return null;

        const now = new Date();
        const end = new Date(trialEnd);

        // Normalize both to midnight
        const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const endOfTrial = new Date(end.getFullYear(), end.getMonth(), end.getDate());

        const diff = Math.floor((endOfTrial - startOfToday) / (1000 * 60 * 60 * 24));

        return diff >= 0 ? diff : 0;
    }, [store?.store_subscription?.trial_ends_at]);
    
    useEffect(() => {
        const status = store?.store_subscription?.stripe_status;
        const storeId = store?.id;
        if (!storeId) return;
        if (trialDays === null) return;

        if (isCanceled(status)) return;
        
        if (trialDays > 7) return;

        const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
        const storageKey = `payment_popup_date_${storeId}`;
        const lastShownDate = localStorage.getItem(storageKey);

        if (lastShownDate === today) return;

        const timer = setTimeout(() => {
            setShowPaymentModal(true);
            localStorage.setItem(storageKey, today);
        }, 500);

        return () => clearTimeout(timer);
    }, [trialDays, store?.store_subscription?.stripe_status, store?.id]);

    return (
        <div className='topbar-nav'>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <div className="hamburger-box"
                            onClick={() => toggleMenuSidebar()} role="button">
                            <div className="hamburger-inner"/>
                        </div>
                    </li>
                    <li className="nav-item d-md-none pl-2">
                        <Link to="/" className="text-center">
                            <Image src={LogoMobile} alt="Hisably Logo"/>
                        </Link>
                    </li>
                    {/* {
                        !isSubscribed(store) && <li className="nav-item d-none d-md-inline-block ">
                            <Button variant="danger top-nav-refer simple-btn">Subscription Ended Make Payment!</Button>
                        </li>
                    } */}
                     {
                        trialDays !== null && (
                            <li className="nav-item d-none d-md-inline-block ml-3">
                                <span
                                    className="d-inline-flex align-items-center flex-wrap"
                                    style={{
                                    gap: '6px',
                                    background: '#ffe5e5',
                                    border: '1px solid #ff4d4f',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap'
                                    }}
                                >
                                    <i
                                    className="fas fa-clock"
                                    style={{
                                        color: '#ff4d4f',
                                        fontSize: '14px'
                                    }}
                                    />

                                    <span
                                        style={{
                                            fontSize: '12px',
                                            color: '#a8071a',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                        >
                                    {trialDays > 0 ? (
                                        <>
                                        <span style={{ fontWeight: 600 }}>
                                            {trialDays} day{trialDays !== 1 ? '(s)' : ''} left
                                        </span>
                                        <span style={{ marginLeft: 5 }}>
                                            in trial
                                        </span>
                                        </>
                                    ) : (
                                        <span style={{ fontWeight: 600 }}>
                                        Trial Expired
                                        </span>
                                    )}
                                    </span>

                                    <Link
                                    to={{
                                        pathname: "/settings/store-profile",
                                        state: { activeTab: "store_subscription" }
                                    }}
                                    >
                                    <button
                                        
                                        className="trial-pay-btn"
                                        
                                    >
                                        Pay Now
                                    </button>
                                    </Link>
                                </span>
                            </li>
                        )
                    }

                    {
                        user.roles[0] !== 'Super Admin' &&
                        <li className="nav-item d-none d-md-inline-block ">
                            <Link to="/refer" className="btn btn-info top-nav-refer simple-btn">
                                Make Hisably FREE!
                            </Link>
                            {/* <Button variant="info top-nav-refer simple-btn">Make Hisably FREE!</Button> */}
                        </li>
                    }

                    {
                        (user.login_type == 'auto') &&
                        <>
                            <li className="nav-item d-sm-inline-block customer-cupport-bar">
                                <Button variant="info top-nav-refer simple-btn" onClick={switchAdmin}>BACK TO ADMIN</Button>
                            </li>
                            
                        </>
                    }

                    {/* <li className="nav-item d-sm-inline-block customer-cupport-bar">
                        <span className="support-bar">Customer Support (8am to 10pm Mon-Fri) : (617) 683 1899</span>
                    </li> */}
                    {
                        savingState !== undefined &&
                        <li className="nav-item">
                        <span className="nav-link">
                            {
                                !savingState && <><i className="fas fa-cloud"/> Saved To Hisably</>
                            }
                            {
                                savingState && <><i className="fas fa-sync"/> Saving...</>
                            }
                        </span>
                        </li>
                    }
                </ul>

                {/* <form className="form-inline ml-3">
                    <div className="input-group input-group-sm">
                        <input className="form-control form-control-navbar" type="search" placeholder="Search"
                            aria-label="Search"/>
                        <div className="input-group-append">
                            <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"/>
                            </button>
                        </div>
                    </div>
                </form> */}

                <ul className="navbar-nav flex-fill justify-content-end">
                    {/* <li className="nav-item staging-btn">
                        <span className="login-by-btn">STAGING</span>
                    </li> */}
                    {/*<li className="nav-item dropdown order-4 order-md-1">*/}
                    {/*    <Link to="#" data-toggle="dropdown" className="nav-link arrow">*/}
                    {/*        <span className="d-none d-md-inline-block">Message</span><i*/}
                    {/*        className="fas fa-angle-down d-none d-md-inline-block"/><i className="fas fa-comments d-md-none"/>*/}
                    {/*    </Link>*/}
                    {/*    <ul className="dropdown-menu dropdown-menu-right border-1">*/}
                    {/*        <li><Link to="#" className="dropdown-item"><i className="fas fa-list-ul"/> View All </Link></li>*/}
                    {/*    </ul>*/}
                    {/*</li>*/}
                  <li className="nav-item order-1 order-md-2">
                    <div 
                        className={`theme-toggle ${darkMode ? 'dark' : 'light'}`} 
                        onClick={handleThemeChange} 
                        title={darkMode ? "Dark Mode Active - Click to switch to Light Mode" : "Light Mode Active - Click to switch to Dark Mode"}
                    >
                        <div className="toggle-handle">
                        <i className={darkMode ? "fas fa-moon" : "fas fa-sun"}></i>
                        </div>
                    </div>

                    <style jsx>{`
                        .theme-toggle {
                        width: 50px;
                        height: 25px;
                        border-radius: 15px;
                        background: ${darkMode ? 'rgb(99 95 95 / 80%) !important' : '#e0e0e0cc'}; /* dark mode: slightly transparent black */
                        display: flex;
                        align-items: center;
                        padding: 2px;
                        cursor: pointer;
                        position: relative;
                        transition: background 0.4s ease;
                        box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                        }

                        .toggle-handle {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        background: #01BF9D;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: ${darkMode ? '#000' : '#fff'};
                        transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1), background 0.4s ease, color 0.4s ease;
                        transform: translateX(${darkMode ? '25px' : '0'});
                        box-shadow: 0 1px 3px rgba(0,0,0,0.2);
                        }

                        .toggle-handle i {
                        font-size: 12px;
                        transition: transform 0.3s ease;
                        }

                        .theme-toggle:hover .toggle-handle i {
                        transform: rotate(${darkMode ? '-20deg' : '20deg'});
                        }
                    `}</style>
                    </li>


                    {
                        user.roles[0] !== 'Super Admin' &&
                        <li className="nav-item dropdown order-2 order-md-2">
                            
                            <Link to="#" data-toggle="dropdown" className="nav-link arrow">
                                <span className="d-none d-md-inline-block">Quick Links</span><i className="fas fa-plus-circle"/>
                            </Link>

                            <div className="dropdown-menu dropdown-menu-xxl dropdown-menu-right border-1 quick-link-dropdown">
                                <a className="close-drop"><i className="fas fa-times"/></a>
                                <Row>
                                    <Col>
                                        <h4>Lottery</h4>
                                        <div className="list-group">
                                            {
                                                lottery_quick_links.map(function (route, index) {
                                                    return <PermissionCheck key={index} permissions={route?.permissions}>
                                                        <Link to={route?.parent_path + route?.path} className="dropdown-item">
                                                            {route?.name}
                                                        </Link>
                                                    </PermissionCheck>
                                                })
                                            }
                                        </div>
                                    </Col>
                                    <Col>
                                        <h4>Create</h4>
                                        <div className="list-group">
                                            {
                                                create_quick_links.map(function (route, index) {
                                                    return <PermissionCheck key={index} permissions={route?.permissions}>
                                                        <Link to={route?.parent_path + route?.path} className="dropdown-item">
                                                            {route?.name}
                                                        </Link>
                                                    </PermissionCheck>
                                                })
                                            }
                                        </div>
                                    </Col>
                                    {
                                        store?.settings?.isGasReportDailyReport?.value != '0' &&
                                        <Col>
                                            <h4>Gas</h4>
                                            <div className="list-group">
                                                {
                                                    gas_quick_links.map(function (route, index) {
                                                        return <PermissionCheck key={index} permissions={route?.permissions}>
                                                            <Link to={route?.parent_path + route?.path}
                                                                className="dropdown-item">
                                                                {route?.name}
                                                            </Link>
                                                        </PermissionCheck>
                                                    })
                                                }
                                            </div>
                                        </Col>
                                    }
                                    <Col>
                                        <h4>Other</h4>
                                        <div className="list-group">
                                            {
                                                other_quick_links.map(function (route, index) {
                                                    return <PermissionCheck key={index} permissions={route?.permissions}>
                                                        <Link to={route?.parent_path + route?.path} className="dropdown-item">
                                                            {route?.name}
                                                        </Link>
                                                    </PermissionCheck>
                                                })
                                            }
                                            <Button className="dropdown-item" onClick={() => {
                                                logOutApi().then(() => {
                                                    window.location.reload()
                                                })
                                            }}>
                                                Log Out
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </li> 
                    }
                    <li className="nav-item dropdown order-3 order-md-3">
                        <Link to="#" data-toggle="dropdown" className="nav-link arrow">
                            <span className="d-none d-md-inline-block">
                                Hi, {userName.split(' ').slice(0, -1).join(' ')}&nbsp;
                            </span>
                            <i className="fas fa-angle-down d-none d-md-inline-block"/>
                            <i className="fas fa-user user-icon d-md-none"/>
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-right border-1">
                            <PermissionCheck permissions={['store_profile.page']}>
                                <li>
                                    <Link to='/settings/store-profile' className="dropdown-item">
                                        <i className="fas fa-unlock"/> Store Profile
                                    </Link>
                                </li>
                            </PermissionCheck>
                            <li>
                                <Link to="/change-password" className="dropdown-item">
                                    <i className="fas fa-unlock"/> Change Password
                                </Link>
                            </li>
                            <li>
                                <button className="dropdown-item"  onClick={async () => {
                                    try {
                                        await removeFCMToken(); 

                                        await logOutApi();

                                        window.location.reload();
                                    } catch (error) {
                                        console.error("Logout Error:", error);
                                    }
                                }}
                                >
                                    <i className="fas fa-sign-out-alt"/>Logout
                                </button>
                            </li>
                        </ul>
                    </li>
                    {
                        user.roles[0] === 'Super Admin' && (        
                        <li className="nav-item order-1 order-md-2 m-2">
                            <NotificationBell />
                        </li>
                        )
                    }
                    {
                        user.roles[0] !== 'Super Admin' &&
                        <li className="nav-item dropdown order-1 order-md-4">
                            <Link to="#" data-toggle="dropdown" className="nav-link arrow store-link">
                                <i className="fas fa-user user-icon d-none d-md-inline-block"/>
                                <i className="fas fa-store d-md-none"/>
                                <span>{store !== null ? store.name : "Select Store"}</span><i className="fas fa-angle-down"/>
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-right border-1">
                                {
                                    stores.map(row => <li key={row.id}>
                                        <button className="dropdown-item" onClick={() => {
                                            if (row !== store) {
                                                switchStore(row);
                                            }
                                        }}>
                                            {row.name}
                                        </button>
                                    </li>)
                                }
                            </ul>
                        </li>
                    }
                </ul>
            </nav>
            {
                <TopNav navMenu={segment}/>
            }

       <Modal
            show={showPaymentModal}
            onHide={() => setShowPaymentModal(false)}
            centered
            >
            <Modal.Header closeButton className="border-0 pb-0" />
            <Modal.Body className="p-4 text-center">

                {/* Icon */}
                <div className="mb-3">
                <i className="fas fa-exclamation-circle text-warning" style={{ fontSize: "40px" }}></i>
                </div>

                {/* Message */}
                <p className="text-muted mb-3" style={{ fontSize: "20px" }}>
                {trialDays > 0 ? (
                    <>
                    Your free trial ends in{" "}
                    <strong className="text-dark">
                        {trialDays} day{trialDays !== 1 ? "s" : ""}
                    </strong>.
                    </>
                ) : (
                    <>
                    Your free trial has ended. Please choose a plan to continue using the service.
                    </>
                )}
                </p>

                {/* CTA Button */}
                <Link
                to={{
                    pathname: "/settings/store-profile",
                    state: { activeTab: "store_subscription" },
                }}
                className="d-block"
                >
                <Button
                    onClick={() => setShowPaymentModal(false)}
                    className="py-2 fw-semibold"
                    variant={"primary"}
                >
                    View plans and proceed with payment
                </Button>
                </Link>

                {/* Help */}
                <p className="text-muted mt-3 mb-0" style={{ fontSize: "14px" }}>
                Need help? Call us at <strong>(617) 683 1899</strong>
                </p>

            </Modal.Body>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state) => ({
    saving: state.App.saving,
    stores: state.Auth.user.stores,
    userName: state.Auth.user.name,
    store: state.App.store,
    user: state.Auth.user,
    darkMode: state.App.darkMode,
})

export default connect(mapStateToProps)(Header);
